import { ReactNode } from "react";

import { Card, Form } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

import { ReferentialType } from "@/_constants/referentialType.ts";
import DropReverse from "@/assets/svg/dropReverse.svg";
import Flake from "@/assets/svg/flake.svg";
import Heater from "@/assets/svg/heater.svg";
import { LabelForm } from "@/common/components/form/LabelForm.tsx";
import SelectForm from "@/common/components/form/SelectForm.tsx";
import ToggleButtonForm from "@/common/components/form/ToggleButtonForm.tsx";




const LayoutCard = ({
  children,
  title,
  icon,
}: {
  children: ReactNode;
  title: string;
  icon: string;
}) => {
  return (
    <Card style={{ width: "18rem", borderColor: "rgb(197, 197, 197)" }}>
      <Card.Header>
        <Card.Title className="d-flex gap-3 mb-0">
          <div className="svg-equipments d-flex justify-content-center align-items-center">
            <img
              src={icon}
              alt={icon}
              style={{ width: "30px", height: "30px" }}
            />
          </div>
          <p className="m-0 w-75 d-flex align-items-center fw-bold p-equipments">
            {title}
          </p>
        </Card.Title>
      </Card.Header>
      <Card.Body>{children}</Card.Body>
    </Card>
  );
};

export const EquipmentPropertyForm = () => {
  const { control, watch } = useFormContext();
  const referentials = useSelector(
    (state) => state.referentialReducer.referentials,
  );

  return (
    <div className="bg-container d-flex flex-column gap-3">
      <h3 className="fw-bold main-title" style={{ fontSize: "24px" }}>
        Équipements
      </h3>

      <div
        style={{
          width: "90%",
          margin: "0 auto",
        }}
        className="d-flex align-items-stretch flex-wrap justify-content-between"
      >
        {/*-------Eau chaude-------*/}
        <LayoutCard title="Eau chaude" icon={DropReverse}>
          <ToggleButtonForm
            name="equipments.hotWater.isCollective"
            control={control}
            label="Système :"
            leftToggle={"Collectif"}
            rightToggle={"Individuel"}
          />
          <SelectForm
            style={{ width: "200px" }}
            control={control}
            name="equipments.hotWater.energies"
            label="Énergie(s) :"
            options={referentials[ReferentialType.ENERGY].data}
          />
        </LayoutCard>

        {/*-------Chauffage-------*/}
        <LayoutCard title={"Chauffage"} icon={Heater}>
          <ToggleButtonForm
            name="equipments.heater.isCollective"
            control={control}
            label="Système :"
            leftToggle={"Collectif"}
            rightToggle={"Individuel"}
          />
          <SelectForm
            style={{ width: "200px" }}
            control={control}
            name="equipments.heater.energies"
            label="Énergie(s) :"
            options={referentials[ReferentialType.ENERGY].data}
          />
        </LayoutCard>

        {/*-------Climatisation-------*/}
        <LayoutCard title="Climatisation" icon={Flake}>
          <div className={"d-flex gap-3 align-items-center flex-wrap"}>
            <LabelForm
              className={"form-input"}
              label=" La climatisation est installée ?"
            />
            <Controller
              render={({ field }) => (
                <Form.Check
                  type="switch"
                  className="radio-order my-1"
                  checked={field.value}
                  onChange={(e) => field.onChange(e.target.checked)}
                />
              )}
              name="equipments.airConditioner.isInstalled"
              control={control}
            />
          </div>
          {watch("equipments.airConditioner.isInstalled") ? (
            <div className="d-flex gap-3 align-items-end flex-wrap">
              <ToggleButtonForm
                name="equipments.airConditioner.isCollective"
                control={control}
                label="Système :"
                leftToggle={"Collectif"}
                rightToggle={"Individuel"}
              />
            </div>
          ) : null}
        </LayoutCard>
      </div>
    </div>
  );
};
